<template>
  <div class="tusd-wrap wrap-bg">
    <cube-scroll
      ref="scroll"
      :data="banners"
      :options="scrollOptions"
      :scrollEvents="['scroll-end']"
      @pulling-down="refreshData"
      @scroll-end="scrollEnd"
    >
      <cube-slide class="banner-slide" :data="banners" :options="{click:false}">
        <cube-slide-item v-for="(b,i) in banners" :key="i">
          <a href="javascript:void(0)" @click="toPage(b.Id)">
            <img :src="b.ImageUrl" />
          </a>
        </cube-slide-item>
      </cube-slide>
      <div class="fast-nav">
        <!-- <div class="fast-item" @click="toPage($event,1,'邀请好友')">
          <i class="item-invite"></i>
          <br />
          <span>邀请好友</span>
        </div> -->

        <!-- <div class="fast-item" @click="goPage('download',0)">
          <i class="item-wallet"></i>
          <br />
          <span>下载</span>
        </div> -->

        <div class="fast-item" @click="goPage('wallet',1)">
          <i class="item-wallet"></i>
          <br />
          <span>我的钱包</span>
        </div>
        <div class="fast-item" @click="goPage('order',1)">
          <i class="item-order"></i>
          <br />
          <span>我的订单</span>
        </div>
        <div class="fast-item" @click="changeStatus">
          <i class="item-online"></i>
          <br />
          <span class="online" :class="{downline:downline}">当前{{statusTxt}}</span>
        </div>
      </div>
      <div class="index-content">
        <div class="pending-order">
          <div class="pending-title">
            待处理订单
            <span @click="goPage('order',1)">全部</span>
          </div>
          <div class="order-list">
            <order-item v-for="o in orders" :order="o" :index="0"></order-item>
            <div class="order-noData" v-if="orders.length <1">暂无待处理订单</div>
          </div>
        </div>
      </div>
      <!-- <div class="guidance">
        <div class="guidance-title">新手学院</div>
        <div class="guidance-list clearfix">
          <div
            class="guidance-item"
            v-for="(c,i) in colleges"C
            :key="i"
            :data-url="c.targetUrl"
            @click="toPage($event,i)"
          >
            <img :src="c.imageUrl" />
            <div class="guidance-item-title">{{c.imageDesc}}</div>
          </div>
        </div>
      </div> -->
    </cube-scroll>
  </div>
</template>

<script>
import orderItem from "@/components/orderItem.vue";
export default {
  name: "index",
  data() {
    return {
      shareUrl: "",
      banners: [],
      colleges: [],
      orders: [],
      scrollOptions: {
        pullDownRefresh: {
          threshold: 90,
          stop: 40,
          txt: "刷新成功"
        }
      },
      loadEnd: false,
      statusTxt: "在线",
      downline: false
    };
  },
  components: {
    orderItem: orderItem
  },
  methods: {
    goPage(name, type) {
      if (type == 1) {
        this.$store.commit("setParam", {
          name: "menu",
          prop: "active",
          value: name
        });
      }
      this.$router.push({ name: name });
    },
    toPage(id) {
      this.$router.push({
        name: "banner",
        params: {
          bannerId: id
        }
      });
    },
    changeStatus() {
      return;
      //用户在线状态
      //更新用户在线状态（status：1在线 2离线）
      let that = this;
      var toast= that.common.toast(that,"数据提交中");
      toast.show();
      that.$axios
        .post(_PROXY_ + "/seller/status/update.do", {
          token: that.$store.state.token,
          status: that.downline ? 1 : 2
        })
        .then(res => {
          let data = res.data;
          if (data.success) {
            that.downline = !that.downline;
            if (that.downline) {
              //如果离线
              that.statusTxt = "离线";
            } else {
              that.statusTxt = "在线";
            }
          }
           toast.hide();
        })
    },
    goOrders() {
      let name = "order";
      this.$store.commit("storeParams", {
        name: name,
        current: 3,
        crtIndex: 0
      });
      this.$router.push({ name: name });
    },
    refreshScroll(src) {
      let img = new Image();
      img.src = src;
      img.onload = () => {
        this.$refs.scroll.refresh();
      };
    },
    getBanners() {
      let that = this;
      that.$api.getBanners().then(res => {
        that.loadEnd = true;
        that.banners =res.data;
      });
    },
    getOrders() {
      let that = this;
      function getOrder() {
        var param={
          pageIndex:1,
          pageSize:5,
          type:1
        }
      that.$api.getOrders(param).then((res) => {
         let data = res.data;
         that.orders = res.data.Items;
  			})
      }
      getOrder();
      // window.setInterval(getOrder, 10 * 1000);
    },
    refreshData() {
      this.getBanners();
      this.getOrders();
      this.checkStatus();
    },
    scrollEnd() {
      if (this.loadEnd) {
        this.loadEnd = false;
        if (this.banners.length > 0) {
          this.refreshScroll(this.banners[0].imageUrl);
        }
        this.colleges.map(c => {
          this.refreshScroll(c.imageUrl);
        });
      }
    },
    checkStatus() {
      return false;
      //定时检测心跳
      let that = this;
      function run() {
        that.$axios.post(_PROXY_ + "/seller/status/query.do", {
            token: that.$store.state.token
          })
          .then(res => {
            let data = res.data;
            if (data.success) {
              if (data.result.data === 1) {
                //在线
                that.statusTxt = "在线";
                that.downline = false;
              } else {
                that.statusTxt = "离线";
                that.downline = true;
              }
            }
          });
      }
      run();
      window.setInterval(run, 60 * 1000);
    }
  },
  created() {
    this.refreshData();
    // var that = this
    // document.addEventListener('visibilitychange', function() { 
    //   // console.log(document)
    //     if(document.visibilityState == 'visible') {
    //       // console.log('页面不可见');
    //       that.refreshData();
    //     }
    // });;

  }
};
</script>

<style lang="less" scoped>
.fast-nav {
  display: flex;
  padding: 12px 0px;
  border-top: 1px solid #394464;
  .fast-item {
    flex: 1;
    color: #d9e3fd;
    text-align: center;
    i {
      display: inline-block;
      width: 46px;
      height: 46px;
      margin-bottom: 6px;
      background: url(../assets/images/icons.png) no-repeat;
      background-size: 300%;
      &.item-invite {
        background-position: -44px -8px;
      }
      &.item-wallet {
        background-position: -44px -64px;
      }
      &.item-order {
        background-position: -44px -120px;
      }
      &.item-online {
        background-position: -44px -176px;
      }
    }
  }
}
.index-content {
  margin-top: 10px;
  padding: 0px @space;
  .pending-order {
    .pending-title {
      font-size: 16px !important;
      color: #d9e3fd;
      line-height: 28px;
      span {
        float: right;
        padding: 8px 16px;
        border-radius: 20px;
        background-color: #28355d;
        font-size: 12px !important;
        line-height: 1;
        color: #899cd6;
      }
    }
  }
}
.guidance {
  margin-top: 6px;
  padding: 0px @space 10px;
  .guidance-title {
    font-size: 16px !important;
    color: #d9e3fd;
    line-height: 28px;
  }
  .guidance-list {
    padding: 12px 0px;
    .guidance-item {
      float: left;
      width: 48.5%;
      img {
        width: 100%;
        border-radius: 6px;
      }
      .guidance-item-title {
        margin-top: 8px;
        color: #d9e3fd;
        font-size: 13px !important;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      &:nth-child(2n) {
        float: right;
      }
    }
  }
}
.online {
  color: green;
}
.online.downline {
  color: red;
}
</style>
